const topics = [
   {id: "194461", title: "تحقيقات وحوارات"}
   ,{id: "194463", title: "صحتك"}
   ,{id: "194449", title: "مطبخ حواء"}
   ,{id: "194464", title: "أناقة و جمال"}
   ,{id: "194465", title: "نجوم و فنون"}
   ,{id: "194469", title: "هاى شلة"}
]
export default topics



// WEBPACK FOOTER //
// ./src/components/homescreen/resorts/topics.js